/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Monitoring API
 * A comprehensive portfolio monitoring and reporting tool for DeFi users to track investments/balances across multiple protocols, discover yield opportunities, and generate reports for tax and accounting purposes.  The API enables users to: - Monitor balances and earnings across lending, liquid staking, LP positions, vaults, and traditional staking - Discover new yield opportunities with advanced filtering and sorting - Generate downloadable reports for taxes, accounting, and personal tracking - Aggregate data at multiple levels (combined, by category, by protocol, by wallet) - Track performance over time with historical data
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
export const BASE_PATH = "https://svc.blockdaemon.com".replace(/\/+$/, "");
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
export class BaseAPI {
    basePath;
    axios;
    configuration;
    constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
}
;
export class RequiredError extends Error {
    field;
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
export const operationServerMap = {};
